<!-- 库存管理 -->
<template>
  <div>
    <matrix-tabs :list="tabList" @handleClick="handleClick"></matrix-tabs>
    <template v-if="tab == 'first'">
      <matrix-statistics span="5" :list="statisticsList"></matrix-statistics>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card>
            <div class="title">
              <p>历史库存趋势</p>
              <el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </div>
            <div id="trend"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <div class="title">
              <p>物资分析</p>
            </div>
            <div id="analyse"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-card style="height: 500px;margin-top: 20px">
        <div class="title" style="margin-bottom: 10px;">
          <p>库存详情</p>
        </div>
        <avue-crud :data="data" :option="option" :page.sync="page" class="penetrate">
          <template slot-scope="scope" slot="name6">
            <el-tag type="success" v-if="scope.row.name6 == 3">正常</el-tag>
            <el-tag type="warning" v-if="scope.row.name6 == 1">预警</el-tag>
            <el-tag type="danger" v-if="scope.row.name6 == 2">危险</el-tag>
          </template>
          <template slot-scope="{row, index}" slot="menu">
            <el-button type="text">变动详情</el-button>
            <el-button type="text">客户详情</el-button>
            <el-button type="text">盘库</el-button>
            <el-button type="text">盘库记录</el-button>
          </template>
        </avue-crud>
      </el-card>
    </template>
    <template v-else>
      <el-card style="margin-bottom: 20px;">
        <avue-form :option="option2" class="penetrate"></avue-form>

      </el-card>
      <matrix-statistics span="8" :list="list"></matrix-statistics>
      <el-card style="height: 500px;">
        <div class="title" style="margin-bottom: 10px;">
          <p>盘库记录</p>
        </div>
        <avue-crud :data="data1" :option="option1" :page.sync="page">
          <template slot-scope="scope" slot="name8">
            <el-link type="danger" :underline="false" v-if="scope.row.name8 < 0">{{ scope.row.name8 }}</el-link>
            <el-link :underline="false" v-else>{{ scope.row.name8 }}</el-link>
          </template>
          <template slot-scope="scope" slot="name9">
            <el-link type="danger" :underline="false" v-if="scope.row.name9 < 0">{{ scope.row.name9 }}%</el-link>
            <el-link :underline="false" v-else>{{ scope.row.name9 }}%</el-link>
          </template>
          <template slot-scope="scope" slot="name10">
            <matrix-tag v-if="scope.row.name10 == 0" color="#CA8A04" text="待处理"></matrix-tag>
            <matrix-tag v-if="scope.row.name10 == 1" color="#16A34A" text="已完成"></matrix-tag>
          </template>
        </avue-crud>
      </el-card>
    </template>
    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import matrixTabs from '@/components/matrix/matrix-tabs'
import matrixStatistics from '@/components/matrix/matrix-statistics'
import matrixTag from '@/components/matrix/matrix-tag'
import crudMixins from '@/mixins/crud-mixins'
import { getDefaultSearchTimeRange, getSearchTimePickerOptions } from '@/basic-common/util/common'
import * as echarts from 'echarts';

export default {
  name: "store-management/index/index",
  mixins: [crudMixins],
  components: {
    matrixTabs,
    matrixStatistics,
    matrixTag
  },
  data() {
    return {
      tab: 'first',
      tabList: [{
        label: '库存分析',
        name: 'first'
      }, {
        label: '合规性分析',
        name: 'second'
      }],
      statisticsList: [{
        label: '当前实时库存总量',
        value: 258432,
        unit: ' 吨',
        subhead: '12.5',
        compare: 1,
        compareColor: '#22C55E'
      }, {
        label: '昨日库存量',
        value: 229718,
        unit: ' 吨',
        subhead: '5.2',
        compare: 0,
        compareColor: '#EF4444'
      }, {
        label: '今日铁运入库量',
        value: 42156,
        unit: ' 吨',
        subhead: '8.5',
        compare: 1,
        compareColor: '#22C55E'
      }, {
        label: '今日汽运入库量',
        value: 15742,
        unit: ' 吨',
        subhead: '3.2',
        compare: 1,
        compareColor: '#22C55E'
      }, {
        label: '今日汽运出库量',
        value: 29284,
        unit: ' 吨',
        subhead: '6.8',
        compare: 0,
        compareColor: '#EF4444'
      }],
      value: getDefaultSearchTimeRange('daterange'),
      pickerOptions: getSearchTimePickerOptions('daterange'),
      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 3 // 总条数
      },
      data: [{
        name1: '北京仓库',
        name2: 'A 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 1,
      }, {
        name1: '上海仓库',
        name2: 'V 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 2,
      }, {
        name1: '广州仓库',
        name2: 'D 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 3,
      }],
      option: {
        header: false,
        editBtn: false,
        delBtn: false,
        menuWidth: '300px',
        height: '370px',
        column: [{
          label: '仓库',
          prop: 'name1',
          align: 'center',
          search: true,
          searchLabel: '',
          placeholder: '请选择仓库'
        }, {
          label: '区域',
          prop: 'name2',
          align: 'center',
          search: true,
          searchLabel: '',
          placeholder: '请选择区域'
        }, {
          label: '物资',
          prop: 'name3',
          align: 'center',
          search: true,
          searchLabel: '',
          placeholder: '请选择物资'
        }, {
          label: '实时库存',
          prop: 'name4',
          align: 'center'
        }, {
          label: '堆放时间',
          prop: 'name5',
          align: 'center'
        }, {
          label: '风险状态',
          prop: 'name6',
          align: 'center'
        },]
      },
      list: [{
        label: '本月盘点总数',
        value: 8500,
        tip: '较上月',
        subhead: ' +12.5%',
        compareColor: '#22C55E'
      }, {
        label: '差异数量',
        value: 86,
        tip: '差异率',
        subhead: ' +7.4%',
        compareColor: '#22C55E'
      }, {
        label: '平均差异率',
        value: 3.2,
        unit: '%',
        tip: '较上月',
        subhead: ' -0.5%',
        compareColor: '#EF4444'
      }],
      data1: [{
        name1: '2023-09-15',
        name2: 'A 区',
        name3: 'A-1',
        name4: 'SKU238471',
        name5: '煤炭',
        name6: 100,
        name7: 98,
        name8: -2,
        name9: -2,
        name10: 0
      }, {
        name1: '2023-09-15',
        name2: 'B 区',
        name3: 'B-1',
        name4: 'SKU238472',
        name5: '煤炭',
        name6: 300,
        name7: 200,
        name8: 21,
        name9: 2,
        name10: 1,
      }],
      option1: {
        header: false,
        editBtn: false,
        menuWidth: '120px',
        height: '370px',
        column: [{
          label: '盘点日期',
          prop: 'name1',
          align: 'center'
        }, {
          label: '库区',
          prop: 'name2',
          align: 'center'
        }, {
          label: '区域',
          prop: 'name3',
          align: 'center'
        }, {
          label: '物品编码',
          prop: 'name4',
          align: 'center'
        }, {
          label: '物品名称',
          prop: 'name5',
          align: 'center'
        }, {
          label: '账面数量',
          prop: 'name6',
          align: 'center'
        }, {
          label: '实际数量',
          prop: 'name7',
          align: 'center'
        }, {
          label: '差异数量',
          prop: 'name8',
          align: 'center'
        }, {
          label: '差异率',
          prop: 'name9',
          align: 'center'
        }, {
          label: '状态',
          prop: 'name10',
          align: 'center'
        }]
      },
      option2: {
        menuSpan: 8,
        menuPosition: 'right',
        column: [{
          prop: 'select',
          type: 'select',
          placeholder: '请选择时间范围',
          span: 4,
          dicData: [{
            label: '字典1',
            value: 0
          }, {
            label: '字典2',
            value: 1
          }]
        }, {
          prop: 'select',
          type: 'select',
          placeholder: '请选择差异状态',
          span: 4,
          dicData: [{
            label: '字典1',
            value: 0
          }, {
            label: '字典2',
            value: 1
          }]
        }, {
          prop: 'select',
          type: 'select',
          placeholder: '请选择库区',
          span: 4,
          dicData: [{
            label: '字典1',
            value: 0
          }, {
            label: '字典2',
            value: 1
          }]
        }, {
          prop: 'select',
          type: 'select',
          placeholder: '请选择区域',
          span: 4,
          dicData: [{
            label: '字典1',
            value: 0
          }, {
            label: '字典2',
            value: 1
          }]
        },]
      }
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    handleClick(tab) {
      this.tab = tab.name
      this.$nextTick(() => {
        this.init()
      })
    },
    init() {
      if (this.tab == 'first') {
        this.trendInit()
        this.analyseInit()
      }
    },
    trendInit() {
      let chartDom = document.getElementById('trend');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        },
        yAxis: {
          type: 'value',
          name: '库存量（吨）',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            data: [820, 932, 1101, 1234, 1290, 1330, 1320, 1101, 1234, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#2563EB',
              width: 2,
            },
            itemStyle: {
              color: '#2563EB',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.2,
                  color: 'rgba(37,99,235,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(37,99,235,0.3)'
                }
              ])
            },

          }
        ]
      };
      option && myChart.setOption(option);
    },
    analyseInit() {
      let chartDom = document.getElementById('analyse');
      let myChart = echarts.init(chartDom);
      let option = {
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '70%'],
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 4
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
            data: [
              { value: 1048, name: '无烟煤' },
              { value: 735, name: '烟煤' },
              { value: 580, name: '褐煤' },
            ]
          }
        ]
      };
      option && myChart.setOption(option);
    }
  }
};
</script>
<style scoped lang="scss">
#trend,
#analyse {
  width: 100%;
  height: 400px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
